import InputType from "common/form/InputType";
import { Form, Input } from "decorator-form";
import { TagStylesConfig, TagStylesInput } from '../common/TagStylesConfig';

@Form({title: "Tag View Config"})
export class TagViewConfig {

	@Input({type: InputType.CHECKBOX, title: "Large"})
	public large?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Minimal"})
	public minimal?: boolean;

	@Input({type: InputType.CHECKBOX, title: "round"})
	public round?: boolean;

	@Input({type: TagStylesInput, title: "Default State"})
	public defaultState: TagStylesConfig;

}



// WEBPACK FOOTER //
// ./src/common/views/tag/TagViewConfig.tsx